import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "../pages/CoreComponent";
import { arrayToFormData } from '../utils/functions';
import { toast } from "react-toastify";

interface IProps extends WithTranslation {
    isOpen: boolean,
    handleModal: any
}

enum EReports {
    youtube = 1,
    youtubeMusic = 2,
    rizanova = 3,
    payment = 5,
    dopdoxod = 6
};

interface IState {
    isLoading: boolean,
    youtubeInput: any,
    youtubeMusicInput: any,
    rizanovaInput: any,
    paymentInput: any,
    dopdoxodInput: any,
    file: any
}

class ReportModal extends CoreComponent<IProps, IState> {
    state: IState = {
        isLoading: false,
        youtubeInput: null,
        youtubeMusicInput: null,
        rizanovaInput: null,
        paymentInput: null,
        dopdoxodInput: null,
        file: null
    }

    uploadReport(e: any, type: EReports) {
        if (confirm("Загрузить выбранный файл?") && e.target.files.length > 0) {
            this.setState({
                file: e.target.files[0]
            }, async () => {
                toast("Загрузка файла...", { type: "success" });

                let url = `${config.api}/uploads/`;

                if (type == EReports.youtube) {
                    url += `youtube`;
                } else if (type == EReports.youtubeMusic) {
                    url += `youtube-music`;
                } else if (type == EReports.rizanova) {
                    url += `rizanova-music`;
                } else if (type == EReports.payment) {
                    url += `payment`;
                } else if (type == EReports.dopdoxod) {
                    url += `dopdoxod`;
                }

                let response: AxiosResponse = await Axios.post(url, arrayToFormData({
                    file: this.state.file
                }));

                if (response.data.status == "success") {
                    toast("Отчёт успешно загружен. Количество сохранённых строк: " + response.data.saved, { type: "success" });
                    if (response.data.errors)
                        toast("Ошибки: " + response.data.errors, { type: "warning" });
                } else {
                    toast("Ошибка сервера.", { type: "error" });
                }

                this.setState({
                    file: null
                });
            })
        } else {
            this.setState({
                file: null
            });
            toast("Отменён.", { type: "info" });

            this.state.youtubeInput.value = null;
            this.state.youtubeMusicInput.value = null;
            this.state.rizanovaInput.value = null;
            this.state.paymentInput.value = null;
            this.state.dopdoxodInput.value = null;
        }

    }

    render() {
        return (
            <div className={"popup " + (this.props.isOpen ? "d-flex" : "")}>
                <div className="popup__content" style={{ height: "auto" }}>
                    <img onClick={() => this.props.handleModal()} src="img/Icon ionic-md-add.png" alt="" className="popup-del" />
                    <h1 className="popup__title">Выберите тип отчета для загрузки</h1>

                    <div id="official-signup">
                        <input type="file" className="d-none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref={ref => this.state.youtubeInput = ref} onClick={(e: any) => {
                            e.stopPropagation();
                        }} onChange={(e: any) => {
                            this.uploadReport(e, EReports.youtube);
                        }} />
                        <input type="file" className="d-none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref={ref => this.state.youtubeMusicInput = ref} onClick={(e: any) => {
                            e.stopPropagation();
                        }} onChange={(e: any) => {
                            this.uploadReport(e, EReports.youtubeMusic);
                        }} />
                        <input type="file" className="d-none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref={ref => this.state.rizanovaInput = ref} onClick={(e: any) => {
                            e.stopPropagation();
                        }} onChange={(e: any) => {
                            this.uploadReport(e, EReports.rizanova);
                        }} />
                        <input type="file" className="d-none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref={ref => this.state.paymentInput = ref} onClick={(e: any) => {
                            e.stopPropagation();
                        }} onChange={(e: any) => {
                            this.uploadReport(e, EReports.payment);
                        }} />
                        <input type="file" className="d-none" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref={ref => this.state.dopdoxodInput = ref} onClick={(e: any) => {
                            e.stopPropagation();
                        }} onChange={(e: any) => {
                            this.uploadReport(e, EReports.dopdoxod);
                        }} />

                        <div className="popup__items flex-wrap">
                            <div className="popup__item d-flex justify-content-center flex-wrap">
                                <a role="button" className="report-item" onClick={() => this.state.youtubeInput.click()}>
                                    <img src="/img/youtube.png" className="mw-100" alt="" />
                                </a>

                                <a role="button" className="report-item" onClick={() => this.state.youtubeMusicInput.click()}>
                                    <img src="/img/youtube-music.png" className="mw-100" alt="" />
                                </a>
                            </div>
                            <div className="popup__item d-flex justify-content-center flex-wrap">
                                <a role="button" className="report-item" onClick={() => this.state.rizanovaInput.click()}>
                                    <img src="/img/rizanova-music.png" className="mw-100" alt="" />
                                </a>

                                <a role="button" className="report-item" onClick={() => this.state.paymentInput.click()}>
                                    <img src="/img/payment.png" className="mw-100" alt="" />
                                </a>
                            </div>
                            <div className="popup__item d-flex justify-content-center flex-wrap">
                                <a role="button" className="report-item" onClick={() => this.state.dopdoxodInput.click()}>
                                    <img src="/img/dopdoxod.png" className="mw-100" alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ReportModal);